import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteChannelDocument } from './delete.generated';

export const useDeleteChannel = (options: ApiOptions<typeof DeleteChannelDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(DeleteChannelDocument, {
    ...useNotifications(DeleteChannelDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.channels.delete_success'),
    }),
    update(cache, { data }) {
      if (!data?.deleteChannel?.deletedIds.length) return;
      data.deleteChannel.deletedIds.forEach((id) => cache.evict({ id: `Channel:${id}` }));
    },
    ...options,
  });
};
